import React from 'react';
import {
  Modal,
  Margin,
  Heading4,
  P,
  ContentGrid,
  Row,
  Col,
  SecondaryCTAButton,
} from '@ovotech/element-v4';
import styled from 'styled-components';
import { PlanDetails } from '@monovo/ev-anytime';

interface PayAsYouGoModalProps {
  isOpen: boolean;
  onClose: () => void;
  planDetails?: PlanDetails;
}

const StyledHeading4 = styled(Heading4)`
  font-size: 20px;
  font-weight: 700;
  color: #00261c;
  margin-bottom: 8px;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #ebe7e3;
`;

export const PayAsYouGoModal: React.FC<PayAsYouGoModalProps> = ({
  isOpen,
  onClose,
  planDetails,
}) => {
  const pricingText = planDetails?.pricePerKwh
    ? `is a fixed rate of ${planDetails.pricePerKwh} per kWh.`
    : `offers a competitive fixed rate per kWh.`;

  return (
    <Modal
      title="Pay as you go"
      data-testid="payd-modal-header"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Margin bottom={4}>
        <StyledHeading4>Free to join</StyledHeading4>
        <P>Pay only for what you charge, no commitment.</P>
      </Margin>

      <Margin bottom={4}>
        <StyledHeading4>Greener driving, for less</StyledHeading4>
        <P>
          Smart charging lets us charge when the grid has more renewable energy,
          saving you money.
        </P>
      </Margin>

      <Margin bottom={4}>
        <StyledHeading4>Fixed rate freedom</StyledHeading4>
        <P>
          Pay as you go {pricingText}
          Drive as much or as little as you want.
        </P>
      </Margin>

      <Margin bottom={4}>
        <StyledHeading4>No exit fees</StyledHeading4>
        <P>Cancel your plan anytime or easily switch to a monthly plan.</P>
      </Margin>

      <Divider />
      <Margin top={4}>
        <ContentGrid size="12">
          <Row isNested>
            <Col small={12} style={{ textAlign: 'right' }}>
              <SecondaryCTAButton onClick={onClose}>Close</SecondaryCTAButton>
            </Col>
          </Row>
        </ContentGrid>
      </Margin>
    </Modal>
  );
};
